import './Login.scss';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { Image } from 'primereact/image';
import { setToken } from '../../features/authSlice';
import { Language } from '../language/Language';
import { useTranslation } from "react-i18next";
import { useAppSelector } from '../../store/hooks';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { setUserGroup, setUserGroups } from '../../features/sharedSlice';
export interface Customize {
    id: number;
    logo: string;
    primarycolor: string;
    secondarycolor: string;
    startextent: string | null,
}

export const Login = () => {
    const toast = useRef<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [customize, setCustomize] = useState<Customize>();
    const [checkboxStatus, setCheckboxStatus] = useState<boolean>(false);
    const activeLanguage = useAppSelector(state => state.language.activeLanguage);
    const [dialogVisibility, setDialogVisibility] = useState(false)
    const userGroups: any = useAppSelector(state => state.sharedState.userGroups);
    const selectedUserGroup: any = useAppSelector(state => state.sharedState.userGroup);


    useEffect(() => {
        getCustomize();
        rememberMe();
    }, [])

    useEffect(() => {
        localStorage.setItem('activeLanguage', activeLanguage ? activeLanguage : 'tr');
    }, [activeLanguage])

    const getCustomize = () => {
        axios.get(process.env.REACT_APP_BASE_URL + 'rest/v1/customize').then((res) => {
            setCustomize(res.data.customize)
        })
    }
    //remember me seçili ise username ve passwordu saklar 
    const rememberMe = () => {
        const username = localStorage.getItem('username')
        if (username) {
            setUsername(username)
        }
    }

    const getUserGroups = async (userId: number) => {
        const response: any = axios.get(process.env.REACT_APP_BASE_URL + 'rest/v1/user/' + userId + '/groups', { params: { token: getToken() } });
        const userGroups = response.data.groups;
        dispatch(setUserGroups(userGroups));
    }

    const filterPermsByUserGroup = async () => {
        localStorage.setItem('selectedUserGroupId', selectedUserGroup.id)
        const body = {
            username: localStorage.getItem('username'),
            groupId: selectedUserGroup.id
        }
        const response = await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/user/groupToken?token=${getToken()}`, body)
    }

    const getToken = () => {
        return localStorage.getItem('token');
    };



    const onHide = () => {
        setDialogVisibility(false)
    }

    return (
        <div className='login-page'>
            <div className='language-selection'>
                <Language />
            </div>
            <div className='login'>
                <div className='content'>
                    <div className='header'>
                        <img draggable='false' src='sb-logo.png' alt='logo' width='150px' />
                        <p className='logo-text'>T.C. SANAYİ VE<br></br> TEKNOLOJİ BAKANLIĞI</p>
                    </div>
                    <div className='login-container'>
                        <p className='title'>MEKANSAL YÖNETİM ve <br /><span>DİJİTALLEŞTİRME PROJESİ</span></p>
                        <div className='login-buttons'>
                            <a href='https://sso.sanayi.gov.tr/serviceredirector.aspx?sid=62c2d7b9-2c64-4876-9708-72b419f3e316'>
                                <Button className='butt' >
                                    <img width={50} src="e-devlet-logo.png" alt="e-devlet" />
                                    <p style={{ marginLeft: '1em' }}>e-Devlet Üzerinden Giriş Yapın</p>
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{ width: '100%', height: '100%' }}>
                    {dialogVisibility && <Dialog header={'Kullanıcı Grubu Belirlerme'} className="custom-popup" visible={true}
                        onHide={onHide} closable={false}
                    >{
                            <div>
                                <p>Devam etmek istediğiniz kullanıcı grubunu seçiniz.</p>
                                <Dropdown className='role-dropdown' filter value={selectedUserGroup} options={userGroups} optionLabel='name' onChange={(e: any) => dispatch(setUserGroup(e.target.value))} placeholder='Sanayi alanını seçiniz' style={{ height: '36px', display: 'flex', alignItems: 'center' }} />
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                                    <Button label='Kaydet' onClick={filterPermsByUserGroup}></Button>
                                </div>
                            </div>

                        }
                    </Dialog>}

                </div>
                <Toast ref={toast} position='bottom-center' className='login-toast' style={{ zIndex: '9 !important' }} />
            </div >
        </div>
    )
}